module.exports = __webpack_public_path__ + "img/Rainbow_Logo.4f120c9a.png";